<template>
	<label role="menuitem" class="dropdown-item mb-0">
		<font-awesome-icon icon="upload"></font-awesome-icon>Load from File <input type="file" hidden @change="loadFile" accept="application/json">
	</label>
</template>

<script>
export default {
	data: () => ({
		fileContents: '',
	}),
	methods: {
		loadFile: function( event ) {
			const file = event.target.files[0]
			const reader = new FileReader()

			reader.onload = readerEvent => this.$emit("upload", readerEvent.target.result)
			reader.readAsText(file)
		},
	}
}
</script>

<style scoped>
.has-icon svg {
	margin-right: 5px;
}
</style>